import AddIcon from '@mui/icons-material/Add';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Menu,
  MenuItem,
  Slide,
  Typography,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import CustomTextField from 'components/shared/custom_text_field';
import { useAuth } from 'contexts/auth/auth_context';
import { usePermissions, ModuleEnum, PermissionType } from 'contexts/auth/permission_context';
import useTermOfAdhesion from 'pages/term_of_adhesion/use_term_of_adhesion';
import React, { useState } from 'react';
import { ROUTES } from 'routes/constants';
import { useNavigate } from 'react-router-dom';
import useTermsStore from 'stores/terms/terms.store';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const FiltroTermosAdesao: React.FC = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const {
    setFilterStatus,
    setFilterCity,
    filterStatus,
    filterCity,
    anchorEl,
    setOrderBy,
    handleClick,
    handleClose,
  } = useTermOfAdhesion();

  const { clearFilters, fetchTerms } = useTermsStore();
  const { hasPermission } = usePermissions();

  const handleClearFilters = () => {
    clearFilters();
    setTimeout(() => {
      fetchTerms();
    }, 100);
  };

  const handleChangeStatus = (status: string) => {
    if (status === 'NULL') {
      setFilterStatus(null);
    } else {
      setFilterStatus(status);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: '#0048B6',
        paddingX: '40px',
        height: '70px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '1200px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Button
            variant='outlined'
            endIcon={<ArrowDropDownIcon />}
            sx={{
              color: '#FFFFFF',
              border: '1px solid #FFFFFF',
              borderRadius: '16px',
              paddingX: '16px',
            }}
            onClick={(e) => handleClick(e)}
          >
            Ordenar
          </Button>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)}>
            <MenuItem
              onClick={() => {
                setOrderBy('ASC');
                handleClose();
              }}
            >
              Mais recente
            </MenuItem>
            <MenuItem
              onClick={() => {
                setOrderBy('DESC');
                handleClose();
              }}
            >
              Mais antiga
            </MenuItem>
          </Menu>
          <Button
            variant='outlined'
            endIcon={<ArrowDropDownIcon />}
            sx={{
              color: filterStatus || filterCity ? '#0048B6' : '#FFFFFF',
              backgroundColor:
                filterStatus || filterCity ? '#FFFFFF' : 'transparent',
              border: '1px solid #FFFFFF',
              borderRadius: '16px',
              paddingX: '16px',
            }}
            onClick={() => setOpen(true)}
          >
            Filtrar
          </Button>

          {(filterStatus || filterCity) && (
            <Button
              variant='text'
              startIcon={<CloseIcon />}
              sx={{ color: '#FFFFFF' }}
              onClick={handleClearFilters}
            >
              Limpar filtros
            </Button>
          )}
        </Box>

        {hasPermission(ModuleEnum.ADHESION_TERM, PermissionType.CREATE) && (
          <Button
            variant='outlined'
            startIcon={<AddIcon />}
            sx={{ color: '#FFFFFF', border: '1px solid #FFFFFF' }}
            onClick={() => navigate(ROUTES.REGISTERTERMOFADHESION)}
          >
            CADASTRAR TERMO DE ADESÃO
          </Button>
        )}
      </Box>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullScreen
        TransitionComponent={Transition}
        sx={{
          '& .MuiPaper-root': {
            height: 'auto',
            width: '100%',
            position: 'fixed',
            bottom: 0,
            margin: 0,
            display: 'flex',
            alignItems: 'center',
          },
        }}
      >
        <Box sx={{ width: '1200px', marginTop: '60px' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                width: '80px',
                height: '5px',
                borderRadius: '100px 0px 0px 0px',
                backgroundColor: '#00000026',
              }}
            />
          </Box>

          <DialogTitle sx={{ padding: 0, marginBottom: '15px' }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                justifyContent: 'space-between',
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Roboto',
                  fontSize: '24px',
                  fontWeight: 500,
                  lineHeight: '38.4px',
                  letterSpacing: '0.15px',
                  textAlign: 'left',
                }}
              >
                Filtrar
              </Typography>
              <Button startIcon={<CloseIcon />} onClick={handleClearFilters}>
                LIMPAR
              </Button>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ padding: 0 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
                <CustomTextField
                  label='Cidade (Opcional)'
                  variant='outlined'
                  size='small'
                  fullWidth
                  value={filterCity}
                  onChange={(e) => setFilterCity(e.target.value)}
                  sx={{
                    marginTop: '10px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      legend: {
                        width: '85px',
                      },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      left: '5px',
                      top: '5px',
                      fontFamily: 'Roboto',
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: '12px',
                      letterSpacing: '0.15px',
                      color: '#00000099',
                    },
                  }}
                />

                <CustomTextField
                  label='Status'
                  variant='outlined'
                  size='small'
                  select
                  fullWidth
                  value={filterStatus || 'NULL'}
                  onChange={(e) => handleChangeStatus(e.target.value)}
                  sx={{
                    marginTop: '10px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      legend: {
                        width: '85px',
                      },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      left: '5px',
                      top: '5px',
                      fontFamily: 'Roboto',
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: '12px',
                      letterSpacing: '0.15px',
                      color: '#00000099',
                    },
                  }}
                >
                  <MenuItem value={'NULL'}>Todos</MenuItem>
                  <MenuItem value={'ATIVO'}>Ativo</MenuItem>
                  <MenuItem value={'PENDENTE'}>Pendente</MenuItem>
                  <MenuItem value={'INATIVO'}>Inativo</MenuItem>
                </CustomTextField>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions
            sx={{
              justifyContent: 'flex-start',
              padding: 0,
              margin: '30px 0px 30px 0px',
            }}
          >
            <Button
              variant='contained'
              size='medium'
              sx={{ backgroundColor: '#0048B6' }}
              onClick={() => {
                setOpen(false);
                fetchTerms();
              }}
            >
              confirmar
            </Button>
            <Button size='medium' onClick={() => setOpen(false)}>
              voltar
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </Box>
  );
};

export default FiltroTermosAdesao;
